import { render, staticRenderFns } from "./addnoticelist.vue?vue&type=template&id=58d36a67&scoped=true&"
import script from "./addnoticelist.vue?vue&type=script&lang=js&"
export * from "./addnoticelist.vue?vue&type=script&lang=js&"
import style0 from "./addnoticelist.vue?vue&type=style&index=0&id=58d36a67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d36a67",
  null
  
)

export default component.exports